import React from "react";
import { toast } from "react-toastify";
import { Modal, Button, Alert } from "@/Components/Common/Tailwind";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { API, BACKEND_HOST } from "../../api";
import { getAccessToken } from "../../api/auth";

type VoucherInfo = {
  id: string | number;
  voucher_id: string | number;
  name: string;
  expire_date: string;
  voucher_state: string;
};

interface UserVoucherGiftUseModalProps {
  setVisible: (value: boolean) => void;
  visible: boolean;
  info: VoucherInfo;
  setInfo: (value: Partial<VoucherInfo>) => void;
  needRefresh: () => void;
}

const UserVoucherGiftUseModal: React.FC<UserVoucherGiftUseModalProps> = ({
  setVisible,
  visible,
  info,
  setInfo,
  needRefresh,
}) => {
  const [checkModal, setCheckModal] = React.useState<boolean>(false);
  const [checkQrCode, setCheckQrCode] = React.useState<string>("");

  const togModal = () => {
    setVisible(!visible);
    setCheckQrCode("");
  };

  const togCheckModal = () => {
    setCheckModal(!checkModal);
  };



  const changeReserv = async () => {
    const accessToken = getAccessToken();

    try {
      const response = await API.put(`/voucher/use-user-voucher-gift/${info.id}/`, null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        // data: { id: info.id, uservoucher: "입장" },
      });

      const data = response.data;

      return data;
    } catch (error) {
      console.log(error);
      // 오류 처리를 추가하거나 throw를 사용하여 상위 호출자에게 전달할 수 있습니다.
    }
  };

  return (
    <React.Fragment>
      <Modal toggle={togModal} isOpen={visible} centered>
        <div>
          {/* qr코드 받아올 시에 그려야함 */}
          <div className="mb-4 flex justify-center">
            {/* {checkQrCode ?
                            <QRCodeSVG value={checkQrCode} />
                            :
                            <Button onClick={() => {
                                getQrCode().then(obj => {
                                    console.log(obj);
                                    setCheckQrCode(obj.qr);
                                })
                            }}
                                className="inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                            >QR 생성하기</Button>
                        } */}
          </div>
          <ul className="list-group">
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">ID :</span>
              <span>{info.voucher_id}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">상품명 :</span>
              <span>{info.name}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">만기일 :</span>
              <span>{info.expire_date}</span>
            </li>
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">상태 :</span>
              <span>{info.voucher_state}</span>
            </li>
          </ul>
        </div>
        <div className="flex justify-center gap-2 mt-4">
          <Button
            variant="outline"
            className="bg-white"
            onClick={() => {
              setInfo({});
              setVisible(!visible);
              setCheckQrCode("");
            }}
          >
            닫기
          </Button>
          <Button
            // onClick={() => {
            //   setVisible(!visible);
            //   setCheckModal(!checkModal);
            // }}
            onClick={() => {
              const confirmReserv = window.confirm("정말 사용하시겠습니까?");
              if (confirmReserv) {
                changeReserv().then((data) => {
                  if (data?.result === "ok") {
                    toast.error("예약 상태가 변경되었습니다!");
                    setVisible(!visible);
                    // alert("예약 상태가 변경되었습니다! " + JSON.stringify(obj))
                    needRefresh();
                  } else {
                    toast.error("예약 상태 변경 실패");
                  }
                });
              }
            }}
            variant="primary"
            style={{
              backgroundColor: "var(--color-success)",
              borderColor: "var(--color-success)",
              color: "var(--color-text-inverse)",
            }}
          >
            직원확인
          </Button>
        </div>
      </Modal>
      {/* <Modal toggle={togCheckModal} isOpen={checkModal} centered>
        <div className="my-4 mx-2">
          <h5 className="modal-title mb-3" id="staticBackdropLabel">
            교환권 사용
          </h5>
          <p className="text-muted mb-4">정말 사용하시겠습니까</p>
          <div className="flex flex-row items-center gap-2 justify-content-around">
            <Link
              to="#"
              className="inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              onClick={() => {
                setCheckModal(false);
                changeReserv().then((obj) => {
                  // console.log
                  // toast.error("교환권 상태가 변경되었습니다!")
                  // alert("교환권 상태가 변경되었습니다! " + JSON.stringify(obj))
                  needRefresh();
                });
              }}
            >
              <i className="ri-check-line me-1 align-middle "></i>사용하기
            </Link>
            <Link
              to="#"
              className="legacy-btn btn-link link-success fw-medium"
              onClick={() => {
                setCheckModal(false);
              }}
            >
              <i className="ri-close-line me-1 align-middle"></i> 사용안함{" "}
            </Link>
          </div>
        </div>
      </Modal> */}
    </React.Fragment>
  );
};
export default UserVoucherGiftUseModal;
